// extracted by mini-css-extract-plugin
export default {"navContainer":"NavbarDashboard_navContainer__2mIVW","navLink":"NavbarDashboard_navLink__3zzVk","active":"NavbarDashboard_active__RuQra"};